import { Service } from '../Service'

const ENDPOINTS = {
  GET: 'Contacts/Get',
  GET_DYNAMIC: 'Contacts/GetAllDynamic',
  POST: 'Contacts/Create',
  PATCH: 'Contacts/Patch',
  PUT: 'Contacts/Put',
  DELETE: 'Contacts/Delete',
  CLOSE_PO: 'Contacts/ClosePO'
}

class ModuleServiceContacts extends Service {
  async checkEmail ({ email }) {
    const params = {
      filter: `email=="${email}"`
    }
    const { data: { value } } = await this.getAllDynamic(params)

    if (value && value.length) {
      const message = window.app.L10n('error-contact-email-exist')
      throw new Error(message)
    }

    return 'Done'
  }
  async getInvoicePaymentContacts ({ companyID }) {
    return this.getAllDynamic({
      select: 'id,email,name',
      filter: `companyID=${companyID}&&divisionID==23&&email!=null`
    })
  }
}

export const ServiceContacts = new ModuleServiceContacts({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})
